/*
 * @Description:
 * @Author: 王赵坤
 * @Date: 2026-07-24 09:07:39
 * @LastEditors: 王赵坤
 * @LastEditTime: 2026-07-24 09:10:16
 */

import Axios from 'axios'
import VueCookies from 'vue-cookies'
import router from '../router/index.js'
import { Message } from 'element-ui';
// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.post['Access-Control-Allow-Origin'] = '*';
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  if (VueCookies.get('token')) {
    //用户登录完成之后 ，每次请求都携带请求头的token值，
    config.headers.Authorization = "Bearer " + VueCookies.get('token')
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 响应拦截器，对错误进行想要进行的处理
Axios.interceptors.response.use((response) => {
  if (response.data.code == 401) {
    return router.push({ name: 'Login' })
  }

  if (response.data.code == 409) {
    Message.error(response.data.message);
    VueCookies.remove('token');
    router.push({
      path: "/login",
    })
  }
  return response;
}, (err) => {
  console.log('err', err)

  if (err.response) {
    console.log(err.response);
    if (err.response.data && err.response.data.code) {
      if (err.response.data.errors) {
        let msg = "";
        let errMessage = JSON.parse(JSON.stringify(err.response.data.errors));
        for (let key in errMessage) {
          msg += errMessage[key] + "<br>";
        }
        err.message = msg;
      } else {
        err.message = err.response.data.message;
      }
      if (err.response.data.code == 401) {
        window.location.href = "/login";
      }
    } else {
      err.message = "其他错误";
    }
  }
  return Promise.reject(err)
});
export default Axios



// WEBPACK FOOTER //
// ./src/restful/axios.js